import React, { useEffect, useRef, useState } from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import "./PostmortemFilters.css";

function PostmortemFilters({ filters, priorities, statuses, onChange, onClear }) {
  const [openFilter, setOpenFilter] = useState(null);
  const filterRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!filterRef.current?.contains(event.target)) setOpenFilter(null);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const updateFilter = (field, value) => {
    onChange({ ...filters, [field]: value });
  };

  const toggleOption = (field, value) => {
    const selectedValues = filters[field];
    const nextValues = selectedValues.includes(value)
      ? selectedValues.filter((selectedValue) => selectedValue !== value)
      : [...selectedValues, value];
    updateFilter(field, nextValues);
  };

  const renderMultiSelect = (field, label, options) => {
    const selectedValues = filters[field];
    const isOpen = openFilter === field;
    return (
      <div className="postmortem-filter-multiselect">
        <span className="postmortem-filter-label">{label}</span>
        <button
          type="button"
          className={`postmortem-filter-trigger${selectedValues.length ? " is-active" : ""}${isOpen ? " is-open" : ""}`}
          aria-expanded={isOpen}
          onClick={() => setOpenFilter(isOpen ? null : field)}
        >
          <span>{selectedValues.length ? `${selectedValues.length} selected` : `All ${label.toLowerCase()}`}</span>
          <McIcon icon="chevron-down" size="16" />
        </button>
        {isOpen && (
          <div className="postmortem-filter-options">
            <div className="postmortem-filter-options-actions">
              <button type="button" onClick={() => updateFilter(field, options)}>Select all</button>
              <button type="button" onClick={() => updateFilter(field, [])}>Clear</button>
            </div>
            {options.map((option) => (
              <label key={option} className="postmortem-filter-option">
                <input type="checkbox" checked={selectedValues.includes(option)} onChange={() => toggleOption(field, option)} />
                <span>{option}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <section ref={filterRef} className="postmortem-filters" aria-label="Filter postmortems">
      <div className="postmortem-filters-heading">
        <McIcon icon="funnel" size="16" />
        <span>Filters</span>
      </div>
      {renderMultiSelect("priority", "Priority", priorities)}
      {renderMultiSelect("status", "Status", statuses)}
      <label className="postmortem-filter-control postmortem-filter-search">
        <span>Impacted CI</span>
        <input value={filters.ci} onChange={(event) => updateFilter("ci", event.target.value)} placeholder="Search CI" />
      </label>
      <label className="postmortem-filter-control postmortem-filter-search">
        <span>Caused By CI</span>
        <input value={filters.causedByCi} onChange={(event) => updateFilter("causedByCi", event.target.value)} placeholder="Search caused by CI" />
      </label>
      <label className="postmortem-filter-control postmortem-filter-search">
        <span>Caused By Portfolio</span>
        <input value={filters.portfolio} onChange={(event) => updateFilter("portfolio", event.target.value)} placeholder="Search portfolio" />
      </label>
      <button type="button" className="postmortem-filters-clear" onClick={onClear} disabled={!filters.priority.length && !filters.status.length && !filters.ci && !filters.causedByCi && !filters.portfolio && !filters.incidentId}>
        Clear
      </button>
    </section>
  );
}

export default PostmortemFilters;